export default __webpack_public_path__ + "static/media/Bold.5a798a20.eot";